var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgHeart = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.48975 16.4266L5.4898 16.4266C7.92522 18.7209 10.8208 20.4133 12.7996 21.3925L12.8022 21.3937C13.0928 21.5354 13.4347 21.5354 13.7253 21.3937L13.7279 21.3924C15.7069 20.4131 18.6023 18.7207 21.0377 16.4266L21.0377 16.4266C23.4639 14.1409 25.5331 11.169 25.5331 7.66948C25.5331 3.90304 22.6529 0.5 18.3459 0.5C16.0534 0.5 14.4473 1.51456 13.2637 2.91069C12.0801 1.51452 10.4739 0.5 8.18157 0.5C3.87452 0.5 0.994385 3.90309 0.994385 7.66948C0.994385 11.1689 3.06362 14.1405 5.48975 16.4266Z",
    fill: "white",
    stroke: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHeart, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Heart.fd1a2087.svg";
export { ForwardRef as ReactComponent };